import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

const RouteView = {
  name: 'RouteView',
  render: (h) => h('router-view'),
}

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '首页' },
  },
  {
    path: '/auth/login',
    name: 'login',
    component: () => import('@/views/login/index'),
    meta: { title: '管理员登录', isLoginPage: true },
  },
  {
    path: '/manage',
    name: 'manage',
    component: RouteView,
    redirect: '/manage/list',
    children: [
      {
        path: '/manage/list',
        name: 'list',
        component: () => import('@/views/manage/list'),
        meta: { title: '评分管理列表' },
      },
      {
        path: '/manage/add',
        name: 'add',
        component: () => import('@/views/manage/detail/config'),
        meta: { title: '创建评分' },
      },
      {
        path: '/manage/detail/:id',
        name: 'detail',
        component: () => import('@/views/manage/detail/index'),
        meta: { title: '管理中心' },
      },
      {
        path: '/manage/detail/:id/config',
        name: 'detailConfig',
        component: () => import('@/views/manage/detail/config'),
        meta: { title: '评分配置' },
      },
      {
        path: '/manage/detail/:id/contestant',
        name: 'contestantList',
        component: () => import('@/views/manage/detail/contestant/list'),
        meta: { title: '被评人管理' },
      },
      {
        path: '/manage/detail/:id/contestant/add',
        name: 'contestantAdd',
        component: () => import('@/views/manage/detail/contestant/detail'),
        meta: { title: '添加被评人' },
      },
      {
        path: '/manage/detail/:id/contestant/:cid',
        name: 'contestantDetail',
        component: () => import('@/views/manage/detail/contestant/detail'),
        meta: { title: '编辑被评人' },
      },
      {
        path: '/manage/detail/:id/contestant/:cid/voteData',
        name: 'contestantVoteData',
        component: () => import('@/views/manage/detail/contestant/voteData'),
        meta: { title: '评分数据' },
      },
      {
        path: '/manage/detail/:id/contestant/:cid/voteData/:judgeId',
        name: 'contestantVoteDataDetail',
        component: () => import('@/views/manage/detail/contestant/voteDataDetail'),
        meta: { title: '评委评分详情' },
      },
      {
        path: '/manage/detail/:id/group',
        name: 'groupList',
        component: () => import('@/views/manage/detail/group/list'),
        meta: { title: '评委分组' },
      },
      {
        path: '/manage/detail/:id/invite',
        name: 'inviteList',
        component: () => import('@/views/manage/detail/inviteList'),
        meta: { title: '评委邀请' },
      },
      {
        path: '/manage/detail/:id/scoreRule',
        name: 'scoreRuleList',
        component: () => import('@/views/manage/detail/scoreRule/list'),
        meta: { title: '评分规则' },
      },
      {
        path: '/manage/detail/:id/scoreRule/add',
        name: 'scoreRuleAdd',
        component: () => import('@/views/manage/detail/scoreRule/detail'),
        meta: { title: '添加评分项' },
      },
      {
        path: '/manage/detail/:id/scoreRule/:srid',
        name: 'scoreRuleDetail',
        component: () => import('@/views/manage/detail/scoreRule/detail'),
        meta: { title: '编辑评分项' },
      },
      {
        path: '/manage/detail/:id/judgeWhiteList',
        name: 'judgeWhiteList',
        component: () => import('@/views/manage/detail/judgeWhiteList/judgeWhiteList'),
        meta: { title: '评委管理' },
      },
      {
        path: '/manage/detail/:id/judgeWhiteList/votedData',
        name: 'judgeVotedData',
        component: () => import('@/views/manage/detail/judgeWhiteList/judgeVotedData'),
        meta: { title: '评委打分详情' },
      },
      {
        path: '/manage/detail/:id/judgeWhiteListManage',
        name: 'judgeWhiteListManage',
        component: () => import('@/views/manage/detail/judgeWhiteList/judgeWhiteListManage'),
        meta: { title: '评委白名单' },
      },
      {
        path: '/manage/detail/:id/dataAnalysis',
        name: 'dataAnalysisList',
        component: () => import('@/views/manage/detail/dataAnalysis/list'),
        meta: { title: '数据分析' },
      },
      {
        path: '/manage/detail/:id/dataAnalysis/avg',
        name: 'dataAnalysisAvg',
        component: () => import('@/views/manage/detail/dataAnalysis/avg'),
        meta: { title: '数据分析' },
      },
      {
        path: '/manage/detail/:id/dataAnalysis/avgWithoutHLestScore',
        name: 'dataAnalysisAvgWithoutHLestScore',
        component: () => import('@/views/manage/detail/dataAnalysis/avgWithoutHLestScore'),
        meta: { title: '数据分析' },
      },
      {
        path: '/manage/detail/:id/dataAnalysis/selfDefine',
        name: 'dataAnalysisSelfDefine',
        component: () => import('@/views/manage/detail/dataAnalysis/selfDefine'),
        meta: { title: '数据分析' },
      },
    ],
  },
  {
    path: '/judge',
    name: 'judge',
    component: RouteView,
    redirect: '/judge/list',
    children: [
      {
        path: '/judge/entry',
        name: 'judgeEntry',
        component: () => import('@/views/judge/entry'),
        meta: { title: '评分详情' },
      },
      {
        path: '/judge/contestantPreview',
        name: 'judgeContestantPreview',
        component: () => import('@/views/judge/contestantPreview'),
        meta: { title: '被评人信息' },
      },
      {
        path: '/judge/scoreRule',
        name: 'judgeScoreRuleList',
        component: () => import('@/views/judge/scoreRuleList'),
        meta: { title: '评分规则' },
      },
      {
        path: '/judge/contestantList',
        name: 'judgeContestantList',
        component: () => import('@/views/judge/contestantList'),
        meta: { title: '评分中心' },
      },
      {
        path: '/judge/scoreEdit',
        name: 'judgeScoreEdit',
        component: () => import('@/views/judge/scoreEdit'),
        meta: { title: '评分' },
      },
      {
        path: '/judge/contestantDetail/:voteId/:cid',
        name: 'judgeContestantDetail',
        component: () => import('@/views/judge/ratedContestantDetail'),
        meta: { title: '历史打分详情' },
      },
    ],
  },
  {
    path: '/dataDisplay/:voteId',
    name: 'dataDisplay',
    component: () => import('@/views/dataDisplay/index'),
    meta: { title: '数据大屏' },
  },
  {
    path: '/qrcodeScan',
    name: 'qrcodeScan',
    component: () => import('@/views/qrcodeScan/index'),
    meta: { title: '二维码扫描' },
  },
]

const router = new VueRouter({
  routes,
})

router.beforeEach((to, from, next) => {
  // if (to.meta.isLoginPage) {
  //   // 使用 replace 而不是 push，这样不会在历史记录中留下B页面
  //   next({ path: '/c', replace: true })
  //   return
  // }
  // // 如果需要认证但未登录，跳转到登录页
  // if (to.meta.requiresAuth) {
  //   next({ path: '/auth/login' })
  //   return
  // }
  // console.log(to.fullPath.indexOf('/manage') === 0)
  next()
})

export default router
